// extracted by extract-css-chunks-webpack-plugin
module.exports = {"topicTop":"topicTop-1JFY0-Ha","title":"title-10V6Tbb-"};